module.exports = __webpack_public_path__ + "img/upload_images.f3d20112.svg";